<template>
  <component
    v-bind:is="isButton ? 'button' : 'a'"
    class="wl-card-item"
    :class="{ 'wl-card-item--cta': cta }"
    @click.prevent="handleClick"
    :rel="!isButton && rel"
    :href="!isButton && href"
    :target="!isButton && target"
  >
    <span class="wl-card-item__copy">
      <span class="wl-card-item__title">{{ title }}</span>
      <span
        v-for="item in renderIf(subText)"
        :key="item"
        class="wl-card-item__sub-text"
        >{{ subText
        }}<span
          v-if="subTextCompanion"
          class="wl-card-item__sub-text-companion"
          v-text="subTextCompanion"
      /></span>
      <slot />
    </span>
    <span
      v-for="item in renderIf(cta)"
      :key="item"
      class="wl-card-item__cta"
      v-text="cta"
    />
  </component>
</template>

<script>
import helper from '@/assets/js/shared/misc/helpers';

export default {
  name: 'wl-card-item',
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return helper.renderIf(condition);
    },
    handleClick() {
      if (this.href && this.target !== '_self') {
        window.open(this.href);
      } else if (this.href) {
        window.location.href = this.href;
      }

      if (this.handlePostClick) {
        this.handlePostClick();
      }
    }
  },
  props: {
    // Title of the item
    title: {
      type: String,
      required: true
    },
    // If you want to override the rel values
    rel: {
      type: String,
      required: false,
      default: 'noopener noreferrer nofollow'
    },
    // Url to navigate to upon clicking
    href: {
      type: String,
      required: false
    },
    target: {
      type: String,
      required: false,
      default: '_self'
    },
    // Text under the title
    subText: {
      type: String,
      require: false
    },
    // Text under the title that's highlighted
    subTextCompanion: {
      type: String,
      require: false
    },
    // Text for Call to Action
    cta: {
      type: String,
      require: false
    },
    // Make link a button
    isButton: {
      type: Boolean,
      default: false
    },
    // function to run after another window is opened
    handlePostClick: {
      type: Function,
      required: false,
      default: null
    },
    // path for current window to navigate to after another window is opened, use this if handlePostClick does not work due to being routed before click
    postClickLink: {
      type: String,
      required: false
    }
  }
};
</script>
